import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')`
  bottom: 0;
  display: block;
  position: absolute;
  width: 100%;
`;
